import {
  ApolloLink,
  FetchResult,
  Observable,
  Operation,
} from "@apollo/client/core";
import { GraphQLError, print } from "graphql";
import { Client, ClientOptions, createClient } from "graphql-ws";
import appConfig from "./config";
import { AUTH_TOKEN } from "./vue-apollo";

export class WebSocketLink extends ApolloLink {
  private client: Client;
  constructor(options: ClientOptions) {
    super();
    this.client = createClient(options);
  }

  public request(operation: Operation): Observable<FetchResult> {
    return new Observable((sink) => {
      return this.client.subscribe<FetchResult>(
        { ...operation, query: print(operation.query) },
        {
          next: sink.next.bind(sink),
          complete: sink.complete.bind(sink),
          error: (err) => {
            // console.log("ObservableObservableObservable", err);
            if (err instanceof Error) {
              return sink.error(err);
            }
            if (err instanceof CloseEvent) {
              return sink.error(
                // reason will be available on clean closes
                new Error(
                  `Socket closed with event ${err.code} ${err.reason || ""}`
                )
              );
            }
            return sink.error(
              new Error(
                (err as GraphQLError[]).map(({ message }) => message).join(", ")
              )
            );
          },
        }
      );
    });
  }
}

const protocol = appConfig.getGraphqlEndpoint().includes("https")
  ? "wss"
  : "ws";
const url = `${protocol}://${appConfig.getGraphqlEndpoint().replace(
  /(^\w+:|^)\/\//,
  ""
)}`;
export const wsClient = new WebSocketLink({
  url: url,
  //lazyCloseTimeout: 50000,
  retryAttempts: Infinity,
  lazy: true,
  connectionParams: () => {
    const token = localStorage.getItem(AUTH_TOKEN);
    return {
      Authorization: token ? `Bearer ${token}` : "",
    };
  },
});
